import {useEffect} from "react"
import axios from "axios"
import {API_PROJECTS} from "../../constants/apiUrls"
import ProjectsModal from "../../sections/projects-modal/ProjectsModal"
import ProjectsTabs from "../../sections/projects-tabs/ProjectsTabs"
import StProjectsHeader from "../../sections/st-projects-header/StProjectsHeader"
import StProjectsContent from "../../sections/st-projects-content/StProjectsContent"
import StProjectsFooter from "../../sections/st-projects-footer/StProjectsFooter"
import ConfirmationModal from "../../components/confirmation-modal/ConfirmationModal"
import {useTranslation} from "react-i18next"
import {toast} from "react-toastify"
import {useNavigate} from "react-router-dom"
import RequireStLicence from "../../tools/RequireStLicence"
import {useTeamContext} from "../../reactContext/contextCustomHooks/useTeamContext"
import {useSessionContext} from "../../reactContext/contextCustomHooks/useSessionContext"
import {useStProjectsContext} from "../../reactContext/contextCustomHooks/useStProjectsContext"
import useStProjects from "../../swrCustomHooks/useStProjects"
import LoadingComponent from "../../components/loading-component/LoadingComponent"

export default function StProjects() {
    const {t} = useTranslation()
    const {sessionContext} = useSessionContext()
    const {teamContext} = useTeamContext()
    const {stProjectsContext} = useStProjectsContext()
    const {stProjects, mutateStProjects, isLoadingStProjects, isErrorStProjects} = useStProjects(stProjectsContext.tab, stProjectsContext.page)
    let navigate = useNavigate()
    const headersRequest = {headers: {Authorization: `Bearer ${sessionContext.idToken}`}}

    const deleteStProject = (value) => {
        return new Promise((resolve, reject) => {
            if (value) {
                axios.delete(`${API_PROJECTS}/${stProjectsContext.isConfirmationModal.id}`, headersRequest)
                .then(() => {
                    mutateStProjects()
                    toast.success(t("Project deleted"))
                    resolve()
                })
                .catch((error) => {
                    console.error(`DELETE ${API_PROJECTS}/${stProjectsContext.isConfirmationModal.id}: `, error)
                    toast.error(t("An error has occurred"))
                    reject()
                })
            } else {
                resolve()
            }
        })
    }

    const restoreStProject = (value) => {
        return new Promise((resolve, reject) => {
            if (value) {
                axios.put(`${API_PROJECTS}/${stProjectsContext.isConfirmationModal.id}/restore`, {}, headersRequest)
                .then(() => {
                    mutateStProjects()
                    toast.success(t("Project restaured"))
                    resolve()
                })
                .catch((error) => {
                    console.error(`PUT ${API_PROJECTS}/${stProjectsContext.isConfirmationModal.id}/restore: `, error)
                    toast.error(t("An error has occurred"))
                    reject()
                })
            } else {
                resolve()
            }
        })
    }

    useEffect(() => {
        sessionContext.role === "admin" && navigate("/neurowide-dashboard")
    }, [])

    if (isErrorStProjects || isLoadingStProjects || stProjects.message) return <LoadingComponent/>
    return (
        <>
        <RequireStLicence types={teamContext.licenceTypes} redirect={true}>
            <div className="VIEW PROJECTS">
                {stProjectsContext.isConfirmationModal.modal && <ConfirmationModal type={"st-projects"} deleteStProject={deleteStProject} restoreStProject={restoreStProject}/>}
                {stProjectsContext.isModal && <ProjectsModal type={"st"} mutateStProjects={mutateStProjects}/>}
                <ProjectsTabs type={"st"}/>
                <span className="line-w-80"></span>
                <StProjectsHeader/>
                <StProjectsContent projects={stProjects}/>
                <span className="line-w-80"></span>
                <StProjectsFooter/>
            </div>
        </RequireStLicence>
        </>
    )
}